import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import {
  useInsuranceTypeCategoriesQuery,
  useInsertInsuranceTypeMutation,
  useUpdateInsuranceTypeMutation,
  useDeleteInsuranceTypeMutation,
} from "AppQuries/master/InsuranceType/insurancetype";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import ReportTools from "Components/UI/ReportTools";
import ImagePreview from "Components/UI/Image/ImagePreview";
import { BackIcon } from "Components/UI/Icon/Icons";
import { camelToTitle } from "core/Operations/stringFormat";
import { Popconfirm, Switch } from "antd";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
import { toast } from "core/Operations/toast";
const InsuranceType = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useInsuranceTypeCategoriesQuery({
    companyCode: userData?.companyCode,
    isTrue: showActiveOnly,
  });
  const { mutate: deleteInsuranceType } = useDeleteInsuranceTypeMutation();
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [show, setShow] = useState(false);

  const ItemData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteInsuranceType(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Item Deleted Successfully.");
          setShow(false);
          GetItems();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    { title: "Code", dataIndex: "code", sorter: (a, b) => a.code - b.code },
    {
      title: "Insurance Type",
      dataIndex: "insuranceType",
      sorter: (a, b) => a.insuranceType.localeCompare(b.insuranceType),
    },
    // {
    //   title: "Policy No",
    //   dataIndex: "policyNo",
    //   sorter: (a, b) => a.policyNo.localeCompare(b.policyNo),
    // },
    // {
    //   title: "Insurance Period",
    //   dataIndex: "insurancePeriod",
    //   sorter: (a, b) => a.insurancePeriod.localeCompare(b.insurancePeriod),
    // },
    // {
    //   title: "Start Date",
    //   dataIndex: "startDate",
    //   sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
    //   render: (date) => new Date(date).toLocaleDateString(),
    // },
    {
      title: "End Date",
      dataIndex: "endDate",
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      render: (date) => new Date(date).toLocaleDateString(),
    },
    // {
    //   title: "Sum Insured",
    //   dataIndex: "sumInsured",
    //   sorter: (a, b) => a.sumInsured - b.sumInsured,
    //   render: (val) => (val ?? 0).toFixed(2),
    // },
    // { title: "Class", dataIndex: "class", sorter: (a, b) => (a.class || "").localeCompare(b.class || "") },
    // { title: "Employees List", dataIndex: "employeesList", sorter: (a, b) => (a.employeesList || "").localeCompare(b.employeesList || "") },
    // { title: "Purpose", dataIndex: "purpose", sorter: (a, b) => (a.purpose || "").localeCompare(b.purpose || "") },
    // { title: "Abbreviation", dataIndex: "abbreviation", sorter: (a, b) => (a.abbreviation || "").localeCompare(b.abbreviation || "") },
    // {
    //   title: "Responsible By",
    //   dataIndex: "responsibleBy",
    //   sorter: (a, b) => a.responsibleBy.localeCompare(b.responsibleBy),
    // },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      sorter: (a, b) => a.vendorName.localeCompare(b.vendorName),
    },
    // {
    //   title: "Agency Name",
    //   dataIndex: "agencyName",
    //   sorter: (a, b) => a.agencyName.localeCompare(b.agencyName),
    // },
    // {
    //   title: "Address",
    //   dataIndex: "address",
    //   sorter: (a, b) => a.address.localeCompare(b.address),
    // },
    {
      title: "Contact No",
      dataIndex: "contactNo",
      sorter: (a, b) => a.contactNo.localeCompare(b.contactNo),
    },
    // {
    //   title: "Email ID",
    //   dataIndex: "emailID",
    //   sorter: (a, b) => a.emailID.localeCompare(b.emailID),
    // },
    // {
    //   title: "Active Since",
    //   dataIndex: "activeSince",
    //   sorter: (a, b) => new Date(a.activeSince) - new Date(b.activeSince),
    // },
    {
      title: "Attachment",
      dataIndex: "attachment",
      render: (url) =>
        url ? (
          <ImagePreview src={url} alt={"Insurance Attachment"} />
        ) : (
          <div className="text-muted">No image</div>
        ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_insuranceType}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to={`${all_routes.master}/${all_routes.editinsurancetype}/${record.code}`}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          <Can
            accessModule={accessCodes.master}
            accessCode={accessCodes.master_insuranceType}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.code)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  const [excelColumns, setExcelColumns] = useState([]);

  useEffect(() => {
    if (ItemData?.length > 0 && excelColumns?.length === 0) {
      setExcelColumns(
        Object.keys(ItemData?.[0])
          ?.map((key) => ({
            title: camelToTitle(key),
            dataIndex: key,
          }))
          ?.filter(
            (column) =>
              column?.dataIndex !== "action" &&
              column?.dataIndex !== "attachment" &&
              column?.dataIndex !== "activeSince" &&
              column?.dataIndex !== "id"
          )
      );
    }
  }, [ItemData]);

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Company Insurance Details</h4>
                <h6>Manage Compnay Insurance</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={excelColumns}
                data={filteredData}
                fileName="Company Insurance Master"
                isExcel={true}
                isPdf={false}
                isPrint={false}
                pdfTheme="striped"
                refresh={GetItems}
              />
            </div>

            <div className="page-btn">
              <Can
                accessModule={accessCodes.master}
                accessCode={accessCodes.master_insuranceType}
                accessType="haveAdd"
              >
                <Link
                  to={`${all_routes.master}/${all_routes.addinsurancetype}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Add New Insurance Type
                </Link>
              </Can>
            </div>
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link to={`${all_routes.master}`} className="btn btn-secondary">
                  <BackIcon className="me-2" />
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                            checked={showActiveOnly}
                            checkedChildren="Show Active"
                            unCheckedChildren="Show All"
                            onChange={(checked) => setShowActiveOnly(checked)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InsuranceType;
